import * as React from "react";
import { forwardRef } from "react";
const SvgTachoCardStatusTickIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "#20BF6B" }), /* @__PURE__ */ React.createElement("path", { d: "M6 11.8L10.5 16.3L18 8.3", stroke: "white", strokeWidth: 2.4, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTachoCardStatusTickIcon);
export default ForwardRef;
